// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.details-box .form-control {\n  text-align: end;\n}\n.details-box .type-password .form-control {\n  width: calc(100% - 2.35rem);\n  margin-left: auto;\n}\n.details-box .type-password .error-message {\n  margin-left: 2.35rem;\n}\n.details-box .type-password .error-offset {\n  margin-left: calc(41.66667% - 2.35rem);\n}\n", ""]);
// Exports
module.exports = exports;
